/* eslint-disable import/first */
/* eslint-disable import/newline-after-import */
import { memo } from 'react';
import { ResponsivenessHelperDown } from 'helpers/responsiveness';
export { default as MessageIllustration } from './message.svg?react';
export { default as SuccessMessageIllustration } from './success-message.svg?react';

const desktopStyle = { maxWidth: '100%' };
interface Props {
  className?: string;
  style?: React.CSSProperties;
}

import ClapIllustration from './clap.svg?react';
import ClapIllustrationIcon from './clap_icon.svg?react';
export const ClapIllustrationResponsive = memo((props: Props) => {
  return (
    <ResponsivenessHelperDown
      breakpoint="sm"
      beforeBreakpoint={<ClapIllustrationIcon {...props} />}
      afterBreakpoint={<ClapIllustration style={desktopStyle} {...props} />}
    />
  );
});

import DartIllustration from './dart.svg?react';
import DartIllustrationIcon from './dart_icon.svg?react';
export const DartIllustrationResponsive = memo((props: Props) => {
  return (
    <ResponsivenessHelperDown
      breakpoint="sm"
      beforeBreakpoint={<DartIllustrationIcon {...props} />}
      afterBreakpoint={<DartIllustration style={desktopStyle} {...props} />}
    />
  );
});

import TadaIllustration from './tada.svg?react';
import TadaIllustrationIcon from './tada_icon.svg?react';
export const TadaIllustrationResponsive = memo((props: Props) => {
  return (
    <ResponsivenessHelperDown
      breakpoint="sm"
      beforeBreakpoint={<TadaIllustrationIcon {...props} />}
      afterBreakpoint={<TadaIllustration style={desktopStyle} {...props} />}
    />
  );
});

import DirectoryIllustration from './directory.svg?react';
import DirectoryIllustrationIcon from './directory_icon.svg?react';
export const DirectoryIllustrationResponsive = memo((props: Props) => {
  return (
    <ResponsivenessHelperDown
      breakpoint="sm"
      beforeBreakpoint={<DirectoryIllustrationIcon {...props} />}
      afterBreakpoint={
        <DirectoryIllustration style={desktopStyle} {...props} />
      }
    />
  );
});

import HelpMessageIllustration from './help-message.svg?react';
import HelpMessageIllustrationIcon from './help-message_icon.svg?react';
export const HelpMessageIllustrationResponsive = memo((props: Props) => {
  return (
    <ResponsivenessHelperDown
      breakpoint="sm"
      beforeBreakpoint={<HelpMessageIllustrationIcon {...props} />}
      afterBreakpoint={
        <HelpMessageIllustration style={desktopStyle} {...props} />
      }
    />
  );
});

import PeopleIllustration from './people.svg?react';
import PeopleIllustrationIcon from './people_icon.svg?react';
export const PeopleIllustrationResponsive = memo((props: Props) => {
  return (
    <ResponsivenessHelperDown
      breakpoint="sm"
      beforeBreakpoint={<PeopleIllustrationIcon {...props} />}
      afterBreakpoint={<PeopleIllustration style={desktopStyle} {...props} />}
    />
  );
});

import SearchIllustration from './search.svg?react';
import SearchIllustrationIcon from './search_icon.svg?react';
export const SearchIllustrationResponsive = memo((props: Props) => {
  return (
    <ResponsivenessHelperDown
      breakpoint="sm"
      beforeBreakpoint={<SearchIllustrationIcon {...props} />}
      afterBreakpoint={<SearchIllustration style={desktopStyle} {...props} />}
    />
  );
});

import EmptyDirectoryIllustration from './empty-directory.svg?react';
import EmptyDirectoryIllustrationIcon from './empty-directory_icon.svg?react';
export const EmptyDirectoryIllustrationResponsive = memo((props: Props) => {
  return (
    <ResponsivenessHelperDown
      breakpoint="sm"
      beforeBreakpoint={<EmptyDirectoryIllustrationIcon {...props} />}
      afterBreakpoint={
        <EmptyDirectoryIllustration style={desktopStyle} {...props} />
      }
    />
  );
});

export {
  ClapIllustration,
  DartIllustration,
  TadaIllustration,
  DirectoryIllustration,
  HelpMessageIllustration,
  PeopleIllustration,
  SearchIllustration,
};
